import { Redirect, Switch, Route } from "react-router-dom";
// import Dashboard from '../pages/components/Dashboard/Dashboard';
import DashboardWrapper from "../pages/components/Dashboard/DashboardWrapper";
import AddNewChildWrapper from "../pages/components/AddNewChild/AddNewChildWrapper";
import React, { useEffect, useState } from "react";
import MasterPrivateLayout from "../layout/MasterPrivateLayout";
import AddAChildDevice from "../pages/components/ConnectKidsDevice/AddAChildDevice";
import ConnectChildDeviceWrapper from "../pages/components/ConnectKidsDevice/ConnectKidDeviceWrapper";
import ChildDevicePinCode from "../pages/components/ConnectKidsDevice/ChildDevicePinCode";
import ChildProfileCreated from "../pages/components/ConnectKidsDevice/ChildProfileCreated";
import SetDailyLimit from "../pages/components/SetDailyLimit/SetDailyLimit";
import Messages from "../pages/components/Messages/Messages";
import Tasks from "../pages/components/Tasks/Tasks";
import CreateNewTask from "../pages/components/Tasks/CreateNewTask";
import Settings from "../pages/components/Settings/Settings";
import SetupWizard from "../pages/components/SetupWizard/SetupWizard";
import ParentsList from "../pages/components/AddNewParent/ParentsList";
import SetRules from "../pages/components/SetRules/SetRules";
import AddNewParentWrapper from "../pages/components/AddNewParent/AddNewParentWrapper";
import ForgetPinCode from "../pages/components/Auth/Login/Forget-Pin-Code/ForgetPinCode";
import Screenshots from "../pages/components/Screenshots/Screenshots";
import Nudity from "../pages/components/Nudity/Nudity";
import LocateMyFamily from "../pages/components/LocateMyfamily/LocateMyFamily";
import LocationHistory from "../pages/components/LocateMyfamily/LocationHistory";
import MessageMyChild from "../pages/components/LocateMyfamily/MessageMyChild";
import LocateNow from "../pages/components/LocateMyfamily/LocateNow";
import DriveToMyChild from "../pages/components/LocateMyfamily/DriveToMyChild";
import AppActivity from "../pages/components/AppsActivity/AppActivity";
import EditChildProfile from "../pages/components/EditChildProfile/EditChildProfile";
import DeviceSettings from "../pages/components/DeviceSettings/DeviceSettings";

import ScreenShotsSelectApps from "../pages/components/SetRules/ScreenShots/ScreenShotsSelectApps";
// import DailyLimit from '../pages/components/SetRules/TimeSupervision/DailyLimit';
import SetSchedule from "../pages/components/SetRules/TimeSupervision/SetSchedule";
import TimeSupervisionSelectApps from "../pages/components/SetRules/TimeSupervision/TimeSupervisionSelectApps";
import DefaultSettings from "../pages/components/SetRules/DefaultSettings/DefaultSettings";
import ManageNotifications from "../pages/components/SetRules/ManageNotifications/ManageNotifications";
import CopySettings from "../pages/components/SetRules/CopySettings/CopySettings";
import WebActivity from "../pages/components/WebActivity/WebActivity";
import NotificationsV1 from "../pages/components/Notifications/NotificationsV1";
// import Notifications from '../pages/components/Notifications/Notifications';
import ChildContacts from "../pages/components/ChildContacts/ChildContacts";
import Keystrokes from "../pages/components/Keystrokes/Keystrokes";
import KeywordStats from "../pages/components/KeywordStats/KeywordStats";
import SocialMediaCommunication from "../pages/components/SocialMediaCommunication/SocialMediaCommunication";
import LockChildDevice from "../pages/components/LockChildDevice/LockChildDevice";
import WebCategoryBlock from "../pages/components/SetRules/WebMonitoring/WebCategoryBlock";

import {
  userSubscription,
  trialPeriodDataService,
  setTrialPeriod,
  setSubscription,
} from "../pages/AxiosRtk/Settings";

import { useDispatch, useSelector } from "react-redux";
import Credits from "../pages/components/Credits/Credits";
import CallSms from "../pages/components/CallSms/CallSms";
import ScreenTime from "../pages/components/ScreenTime/ScreenTime";
import YoutubeSummary from "../pages/components/YoutubeSummary/YoutubeSummary";
import Gallery from "../pages/components/Gallery/Gallery";
import ActivityDetails from "../pages/components/AppsActivity/ActivityScreen/ActivityDetails";
import RestrictedWebsite from "../pages/components/SetRules/WebMonitoring/RestrictedWebsite";
import AllowedWebsites from "../pages/components/SetRules/WebMonitoring/AllowedWebsites";
import EditKeywords from "../pages/components/SetRules/WebMonitoring/EditKeywords";
import { isEmpty } from "lodash";
import HelpDesk from "../pages/components/HelpDesk";
import DriverTo from "../pages/components/LocateMyfamily/DriveTo";

const PrivateRoutes = () => {
  const allRoutes = [
    {
      path: "/dashboard",
      component: DashboardWrapper,
      restrictedRoute: false,
    },
    {
      path: "/add-a-child-device",
      component: AddAChildDevice,
      restrictedRoute: false,
    },
    {
      path: "/connect-child-device",
      component: ConnectChildDeviceWrapper,
      restrictedRoute: false,
    },
    {
      path: "/pin-code-for-child-device",
      component: ChildDevicePinCode,
      restrictedRoute: false,
    },
    {
      path: "/child-profile-created",
      component: ChildProfileCreated,
      restrictedRoute: false,
    },
    {
      path: "/set-daily-limit",
      component: SetDailyLimit,
      restrictedRoute: false,
    },
    { path: "/messages", component: Messages, restrictedRoute: false },
    { path: "/tasks", component: Tasks, restrictedRoute: false },
    {
      path: "/create-new-task",
      component: CreateNewTask,
      restrictedRoute: false,
    },
    {
      path: "/edit-task",
      component: CreateNewTask,
      restrictedRoute: false,
    },
    {
      path: "/notifications",
      component: NotificationsV1,
      restrictedRoute: false,
    },
    { path: "/settings", component: Settings, restrictedRoute: false },
    {
      path: "/setup-wizard",
      component: SetupWizard,
      restrictedRoute: false,
    },
    { path: "/set-rules", component: SetRules, restrictedRoute: false },
    {
      path: "/set-rules/set-schedule",
      component: SetSchedule,
      restrictedRoute: false,
    },
    {
      path: "/set-rules/time-supervision-allow-apps",
      component: TimeSupervisionSelectApps,
      restrictedRoute: false,
    },
    {
      path: "/set-rules/web-categories",
      component: WebCategoryBlock,
      restrictedRoute: false,
    },
    {
      path: "/set-rules/restricted-websites",
      component: RestrictedWebsite,
      restrictedRoute: false,
    },
    {
      path: "/set-rules/allowed-websites",
      component: AllowedWebsites,
      restrictedRoute: false,
    },
    {
      path: "/set-rules/edit-keywords",
      component: EditKeywords,
      restrictedRoute: false,
    },
    {
      path: "/set-rules/manage-notifications",
      component: ManageNotifications,
      restrictedRoute: false,
    },
    {
      path: "/set-rules/copy-settings",
      component: CopySettings,
      restrictedRoute: false,
    },
    {
      path: "/set-rules/default-settings",
      component: DefaultSettings,
      restrictedRoute: false,
    },
    {
      path: "/screenshots",
      component: Screenshots,
      restrictedRoute: false,
    },
    {
      path: "/manual-screenshots",
      component: Screenshots,
      restrictedRoute: false,
    },
    { path: "/nudity", component: Nudity, restrictedRoute: false },
    {
      path: "/locate-my-family",
      component: LocateMyFamily,
      restrictedRoute: false,
    },
    {
      path: "/driver-to",
      component: DriverTo,
      restrictedRoute: false,
    },
    {
      path: "/location-history",
      component: LocationHistory,
      restrictedRoute: false,
    },
    {
      path: "/message-my-child",
      component: MessageMyChild,
      restrictedRoute: false,
    },
    { path: "/locate-now", component: LocateNow, restrictedRoute: false },
    {
      path: "/drive-to-my-child",
      component: DriveToMyChild,
      restrictedRoute: false,
    },
    {
      path: "/apps-activity",
      component: AppActivity,
      restrictedRoute: false,
    },
    {
      path: "/activity-details/:id",
      component: ActivityDetails,
      restrictedRoute: false,
    },
    {
      path: "/web-activity",
      component: WebActivity,
      restrictedRoute: false,
    },
    {
      path: "/child-contacts",
      component: ChildContacts,
      restrictedRoute: false,
    },
    { path: "/keystrokes", component: Keystrokes, restrictedRoute: false },
    {
      path: "/keyword-stats",
      component: KeywordStats,
      restrictedRoute: false,
    },
    {
      path: "/social-media-communication",
      component: SocialMediaCommunication,
      restrictedRoute: false,
    },
    {
      path: "/lock-child-device",
      component: LockChildDevice,
      restrictedRoute: false,
    },
    { path: "/credits", component: Credits, restrictedRoute: false },
    { path: "/screen-time", component: ScreenTime, restrictedRoute: false },
    { path: "/call-sms", component: CallSms, restrictedRoute: false },
    {
      path: "/youtube-summary",
      component: YoutubeSummary,
      restrictedRoute: false,
    },
    { path: "/gallery", component: Gallery, restrictedRoute: false },
    {
      path: "/edit-your-keywords",
      component: EditKeywords,
      restrictedRoute: false,
    },
    {
      path: "/screen-shot-select-apps",
      component: ScreenShotsSelectApps,
      restrictedRoute: false,
    },
    {
      path: "/keystrokes-select-apps",
      component: ScreenShotsSelectApps,
      restrictedRoute: false,
    },
    {
      path: "/social-media-select-apps",
      component: ScreenShotsSelectApps,
      restrictedRoute: false,
    },
    { path: "/help", component: HelpDesk, restrictedRoute: false },
    {
      path: "/add-new-child",
      component: AddNewChildWrapper,
      restrictedRoute: true,
    },
    {
      path: "/edit-child-profile",
      component: EditChildProfile,
      restrictedRoute: true,
    },
    { path: "/parent-list", component: ParentsList, restrictedRoute: true },
    {
      path: "/add-new-parent",
      component: AddNewParentWrapper,
      restrictedRoute: true,
    },
    {
      path: "/edit-new-parent",
      component: AddNewParentWrapper,
      restrictedRoute: true,
    },
    {
      path: "/forget-pin-code",
      component: ForgetPinCode,
      restrictedRoute: true,
    },
    {
      path: "/device-settings",
      component: DeviceSettings,
      restrictedRoute: true,
    },
  ];

  const [filteredRoutes, setFilteredRoutes] = useState(allRoutes);
  const dispatch = useDispatch();
  const { isAdditionalParent } = useSelector(({ auth }) => auth);

  useEffect(() => {
    dispatch(setTrialPeriod(null));
    dispatch(setSubscription(null));

    if (!isAdditionalParent) {
      userSubscription()
        .then((res) => {
          if (isEmpty(res?.data?.result)) {
            trialPeriodDataService()
              .then((resTrialPeriod) => {
                dispatch(setTrialPeriod(resTrialPeriod?.data?.result[0]));
                dispatch(setSubscription("DATA_NOT_FOUND"));
              })
              .catch((err) => {
                console.log(
                  "trial period catch error ==>>",
                  err?.response?.data?.message
                );
              });
          } else {
            dispatch(setSubscription(res?.data?.result));
          }
        })
        .catch((error) => {
          console.log(
            "subscription catch error ==>>",
            error?.response?.data?.message
          );
        });
    }
    
  }, []);

  useEffect(() => {
    if (isAdditionalParent) {
      setFilteredRoutes(allRoutes.filter((item) => !item?.restrictedRoute));
    }
  }, [isAdditionalParent]);

  return (
    <MasterPrivateLayout>
      <Switch>
        {filteredRoutes?.map((item, index) => (
          <Route path={item?.path} component={item?.component} exact = {true} key ={item?.path} />
        ))}
        <Redirect to="/dashboard" />
      </Switch>
    </MasterPrivateLayout>
  );
};

export default PrivateRoutes;
